export const contactOptions = {
    "Athlete": ["Athelete"],
    "Athlete Competition Partner": ["Performance Partner", "Guide", "Pilot"],
    "Contractor": ["Service Provider"],
    "CPC Support Staff": ["Contractor", "Media Attache", "Brand", "Communications", "Foundation", "Partnerships", "Corporate Services", "Games Operations", "Performance Services", "Support Staff", "Support Staff - Communications & Brand", "Support Staff - Partnerships", "Support Staff - Foundation", "Support Staff - Corporate Services", "Support Staff - Operations", "Support Staff - Performance", "Support Staff - Security", "Sport Medicine - Chief Medical Officer", "Sport Medicine - Chief Therapist", "Sport Medicine - Clinic Manager", "Sport Medicine - Massage Therapist", "Sport Medicine - Physician", "Sport Medicine - Physiotherapist", "Sport Medicine - Athletic Therapist"],
    "Family & Friends": ["Family & Friends Guest", "Family & Friends Volunteer"],
    "Federal Government": ["Sport Minister", "Canadian Embassy", "Federal Delegation", "Sport Canada"],
    "Performance Stakeholder": ["Performance Guest"],
    "Media": ["Videographer", "Photographer", "Journalist"],
    "Sport Staff": ["Assistant Coach", "Attendant", "Coach", "Equipment Manager", "Equipment Technician", "Executive", "Head Coach", "High Performance Director", "Media Attaché", "Personal Coach", "Sport Medicine - Athletic Therapist", "Sport Medicine - Chiropractor", "Sport Medicine - Massage Therapist", "Sport Medicine - Mental Performance", "Sport Medicine - Nutritionist", "Sport Medicine - Physician", "Sport Medicine - Physiologist", "Sport Medicine - Physiotherapist", "Sport Science - Performance Analyst", "Sport Science - Strength & Conditioning Coach", "Tapper", "Team Administrator", "Team Leader", "Team Manager", "Training Partner", "Videographer", "Veterinarian", "Horse Owner", "Groom", "High Performance Director"],
    "Team Leadership": ["Assistant Chef de Mission", "Chef de Mission", "Paralympic Attache"],
    "VIP": ["Board of Directors", "Hospitality Guest", "IPC Guest", "Foundation Guest"],
    "Pronouns": ["He/him/his", "She/her/hers", "They/them/theirs", "Zie/Zir/Zirs", "A pronoun not listed", "No pronoun preference"],
    "Perferred Language": ["English", "French"],
    "Cell Phone Type": ["iPhone", "Android", "Other"],
    "Gender": ["Male", "Female", "Gender X"],
    "Organization": ["Para Alpine", "Para Nordic", "Para Snowboard", "Para Hockey", "Wheelchair Curling", "Canadian Paralympic Committee"],
    "Disablity Type": ["Amputee", "Cerebral Palsy", "Intellectual Impairment", "Les Autres", "Visually Impaired"],
}

export const countries = [
    {
        "name": "CANADA",
        "code": "CAN"
    },
    {
        "name": "AFGHANISTAN",
        "code": "AFG"
    },
    {
        "name": "ALBANIA",
        "code": "ALB"
    },
    {
        "name": "ALGERIA",
        "code": "ALG"
    },
    {
        "name": "ANDORRA",
        "code": "AND"
    },
    {
        "name": "ANGOLA",
        "code": "ANG"
    },
    {
        "name": "ANTIGUA AND BARBUDA",
        "code": "ANT"
    },
    {
        "name": "ARGENTINA",
        "code": "ARG"
    },
    {
        "name": "ARMENIA",
        "code": "ARM"
    },
    {
        "name": "AUSTRALIA",
        "code": "AUS"
    },
    {
        "name": "AUSTRIA",
        "code": "AUT"
    },
    {
        "name": "AZERBAIJAN",
        "code": "AZE"
    },
    {
        "name": "BAHAMAS",
        "code": "BAH"
    },
    {
        "name": "BANGLADESH",
        "code": "BAN"
    },
    {
        "name": "BARBADOS",
        "code": "BAR"
    },
    {
        "name": "BURUNDI",
        "code": "BDI"
    },
    {
        "name": "BELGIUM",
        "code": "BEL"
    },
    {
        "name": "BENIN",
        "code": "BEN"
    },
    {
        "name": "BHUTAN",
        "code": "BHU"
    },
    {
        "name": "BOSNIA AND HERZEGOVINA",
        "code": "BIH"
    },
    {
        "name": "BELIZE",
        "code": "BIZ"
    },
    {
        "name": "BELARUS",
        "code": "BLR"
    },
    {
        "name": "BOLIVIA",
        "code": "BOL"
    },
    {
        "name": "BOTSWANA",
        "code": "BOT"
    },
    {
        "name": "BRAZIL",
        "code": "BRA"
    },
    {
        "name": "BAHRAIN",
        "code": "BRN"
    },
    {
        "name": "BRUNEI DARUSSALAM",
        "code": "BRU"
    },
    {
        "name": "BULGARIA",
        "code": "BUL"
    },
    {
        "name": "BURKINA FASO",
        "code": "BUR"
    },
    {
        "name": "CENTRAL AFRICAN REPUBLIC",
        "code": "CAF"
    },
    {
        "name": "CAMBODIA",
        "code": "CAM"
    },
    {
        "name": "CONGO",
        "code": "CGO"
    },
    {
        "name": "CHAD",
        "code": "CHA"
    },
    {
        "name": "CHILE",
        "code": "CHI"
    },
    {
        "name": "CHINA",
        "code": "CHN"
    },
    {
        "name": "CÔTE D'IVOIRE",
        "code": "CIV"
    },
    {
        "name": "CAMEROON",
        "code": "CMR"
    },
    {
        "name": "D.R. CONGO",
        "code": "COD"
    },
    {
        "name": "COLOMBIA",
        "code": "COL"
    },
    {
        "name": "COMOROS",
        "code": "COM"
    },
    {
        "name": "CAPE VERDE",
        "code": "CPV"
    },
    {
        "name": "COSTA RICA",
        "code": "CRC"
    },
    {
        "name": "CROATIA",
        "code": "CRO"
    },
    {
        "name": "CUBA",
        "code": "CUB"
    },
    {
        "name": "CYPRUS",
        "code": "CYP"
    },
    {
        "name": "CZECH REPUBLIC",
        "code": "CZE"
    },
    {
        "name": "DENMARK",
        "code": "DEN"
    },
    {
        "name": "DJIBOUTI",
        "code": "DJI"
    },
    {
        "name": "DOMINICA",
        "code": "DMA"
    },
    {
        "name": "DOMINICAN REPUBLIC",
        "code": "DOM"
    },
    {
        "name": "ECUADOR",
        "code": "ECU"
    },
    {
        "name": "EGYPT",
        "code": "EGY"
    },
    {
        "name": "ERITREA",
        "code": "ERI"
    },
    {
        "name": "EL SALVADOR",
        "code": "ESA"
    },
    {
        "name": "WESTERN SAHARA",
        "code": "ESH"
    },
    {
        "name": "SPAIN",
        "code": "ESP"
    },
    {
        "name": "ESTONIA",
        "code": "EST"
    },
    {
        "name": "ETHIOPIA",
        "code": "ETH"
    },
    {
        "name": "FIJI",
        "code": "FIJ"
    },
    {
        "name": "FINLAND",
        "code": "FIN"
    },
    {
        "name": "FRANCE",
        "code": "FRA"
    },
    {
        "name": "MICRONESIA",
        "code": "FSM"
    },
    {
        "name": "GABON",
        "code": "GAB"
    },
    {
        "name": "GAMBIA",
        "code": "GAM"
    },
    {
        "name": "GREAT BRITAIN",
        "code": "GBR"
    },
    {
        "name": "GUINEA-BISSAU",
        "code": "GBS"
    },
    {
        "name": "GEORGIA",
        "code": "GEO"
    },
    {
        "name": "EQUATORIAL GUINEA",
        "code": "GEQ"
    },
    {
        "name": "GERMANY",
        "code": "GER"
    },
    {
        "name": "GHANA",
        "code": "GHA"
    },
    {
        "name": "GREECE",
        "code": "GRE"
    },
    {
        "name": "GRENADA",
        "code": "GRN"
    },
    {
        "name": "GUATEMALA",
        "code": "GUA"
    },
    {
        "name": "GUINEA",
        "code": "GUI"
    },
    {
        "name": "GUYANA",
        "code": "GUY"
    },
    {
        "name": "HAITI",
        "code": "HAI"
    },
    {
        "name": "HONG KONG, CHINA",
        "code": "HKG"
    },
    {
        "name": "HONDURAS",
        "code": "HON"
    },
    {
        "name": "HUNGARY",
        "code": "HUN"
    },
    {
        "name": "INDONESIA",
        "code": "INA"
    },
    {
        "name": "INDIA",
        "code": "IND"
    },
    {
        "name": "ISLAMIC REPUBLIC OF IRAN",
        "code": "IRI"
    },
    {
        "name": "IRELAND",
        "code": "IRL"
    },
    {
        "name": "IRAQ",
        "code": "IRQ"
    },
    {
        "name": "ICELAND",
        "code": "ISL"
    },
    {
        "name": "ISRAEL",
        "code": "ISR"
    },
    {
        "name": "ITALY",
        "code": "ITA"
    },
    {
        "name": "JAMAICA",
        "code": "JAM"
    },
    {
        "name": "JORDAN",
        "code": "JOR"
    },
    {
        "name": "JAPAN",
        "code": "JPN"
    },
    {
        "name": "KAZAKHSTAN",
        "code": "KAZ"
    },
    {
        "name": "KENYA",
        "code": "KEN"
    },
    {
        "name": "KYRGYZSTAN",
        "code": "KGZ"
    },
    {
        "name": "KIRIBATI",
        "code": "KIR"
    },
    {
        "name": "REPUBLIC OF KOREA",
        "code": "KOR"
    },
    {
        "name": "KOSOVO",
        "code": "KOS"
    },
    {
        "name": "SAUDI ARABIA",
        "code": "KSA"
    },
    {
        "name": "KUWAIT",
        "code": "KUW"
    },
    {
        "name": "LAO P.D.R.",
        "code": "LAO"
    },
    {
        "name": "LATVIA",
        "code": "LAT"
    },
    {
        "name": "LIBYA",
        "code": "LBA"
    },
    {
        "name": "LEBANON",
        "code": "LBN"
    },
    {
        "name": "LIBERIA",
        "code": "LBR"
    },
    {
        "name": "SAINT LUCIA",
        "code": "LCA"
    },
    {
        "name": "LESOTHO",
        "code": "LES"
    },
    {
        "name": "LIECHTENSTEIN",
        "code": "LIE"
    },
    {
        "name": "LITHUANIA",
        "code": "LTU"
    },
    {
        "name": "LUXEMBOURG",
        "code": "LUX"
    },
    {
        "name": "MACAO, CHINA",
        "code": "MAC"
    },
    {
        "name": "MADAGASCAR",
        "code": "MAD"
    },
    {
        "name": "MOROCCO",
        "code": "MAR"
    },
    {
        "name": "MALAYSIA",
        "code": "MAS"
    },
    {
        "name": "MALAWI",
        "code": "MAW"
    },
    {
        "name": "REPUBLIC OF MOLDOVA",
        "code": "MDA"
    },
    {
        "name": "MALDIVES",
        "code": "MDV"
    },
    {
        "name": "MEXICO",
        "code": "MEX"
    },
    {
        "name": "MONGOLIA",
        "code": "MGL"
    },
    {
        "name": "MARSHALL ISLANDS",
        "code": "MHL"
    },
    {
        "name": "NORTH MACEDONIA",
        "code": "MKD"
    },
    {
        "name": "MALI",
        "code": "MLI"
    },
    {
        "name": "MALTA",
        "code": "MLT"
    },
    {
        "name": "MONTENEGRO",
        "code": "MNE"
    },
    {
        "name": "MONACO",
        "code": "MON"
    },
    {
        "name": "MOZAMBIQUE",
        "code": "MOZ"
    },
    {
        "name": "MAURITIUS",
        "code": "MRI"
    },
    {
        "name": "MAURITANIA",
        "code": "MTN"
    },
    {
        "name": "MYANMAR",
        "code": "MYA"
    },
    {
        "name": "NAMIBIA",
        "code": "NAM"
    },
    {
        "name": "NICARAGUA",
        "code": "NCA"
    },
    {
        "name": "NETHERLANDS",
        "code": "NED"
    },
    {
        "name": "NEPAL",
        "code": "NEP"
    },
    {
        "name": "NIGERIA",
        "code": "NGR"
    },
    {
        "name": "NIGER",
        "code": "NIG"
    },
    {
        "name": "NORWAY",
        "code": "NOR"
    },
    {
        "name": "NAURU",
        "code": "NRU"
    },
    {
        "name": "NEW ZEALAND",
        "code": "NZL"
    },
    {
        "name": "OMAN",
        "code": "OMA"
    },
    {
        "name": "PAKISTAN",
        "code": "PAK"
    },
    {
        "name": "PANAMA",
        "code": "PAN"
    },
    {
        "name": "PARAGUAY",
        "code": "PAR"
    },
    {
        "name": "PERU",
        "code": "PER"
    },
    {
        "name": "PHILIPPINES",
        "code": "PHI"
    },
    {
        "name": "PALESTINE",
        "code": "PLE"
    },
    {
        "name": "PALAU",
        "code": "PLW"
    },
    {
        "name": "PAPUA NEW GUINEA",
        "code": "PNG"
    },
    {
        "name": "POLAND",
        "code": "POL"
    },
    {
        "name": "PORTUGAL",
        "code": "POR"
    },
    {
        "name": "DPR KOREA",
        "code": "PRK"
    },
    {
        "name": "QATAR",
        "code": "QAT"
    },
    {
        "name": "ROMANIA",
        "code": "ROU"
    },
    {
        "name": "SOUTH AFRICA",
        "code": "RSA"
    },
    {
        "name": "RUSSIAN FEDERATION",
        "code": "RUS"
    },
    {
        "name": "RWANDA",
        "code": "RWA"
    },
    {
        "name": "SAMOA",
        "code": "SAM"
    },
    {
        "name": "SENEGAL",
        "code": "SEN"
    },
    {
        "name": "SEYCHELLES",
        "code": "SEY"
    },
    {
        "name": "SINGAPORE",
        "code": "SGP"
    },
    {
        "name": "SAINT KITTS AND NEVIS",
        "code": "SKN"
    },
    {
        "name": "SIERRA LEONE",
        "code": "SLE"
    },
    {
        "name": "SLOVENIA",
        "code": "SLO"
    },
    {
        "name": "SAN MARINO",
        "code": "SMR"
    },
    {
        "name": "SOLOMON ISLANDS",
        "code": "SOL"
    },
    {
        "name": "SOMALIA",
        "code": "SOM"
    },
    {
        "name": "SERBIA",
        "code": "SRB"
    },
    {
        "name": "SRI LANKA",
        "code": "SRI"
    },
    {
        "name": "SOUTH SUDAN",
        "code": "SSD"
    },
    {
        "name": "SAO TOME & PRINCIPE",
        "code": "STP"
    },
    {
        "name": "SUDAN",
        "code": "SUD"
    },
    {
        "name": "SWITZERLAND",
        "code": "SUI"
    },
    {
        "name": "SURINAME",
        "code": "SUR"
    },
    {
        "name": "SLOVAKIA",
        "code": "SVK"
    },
    {
        "name": "SWEDEN",
        "code": "SWE"
    },
    {
        "name": "ESWATINI",
        "code": "SWZ"
    },
    {
        "name": "SYRIAN ARAB REPUBLIC",
        "code": "SYR"
    },
    {
        "name": "TANZANIA",
        "code": "TAN"
    },
    {
        "name": "TONGA",
        "code": "TGA"
    },
    {
        "name": "THAILAND",
        "code": "THA"
    },
    {
        "name": "TAJIKISTAN",
        "code": "TJK"
    },
    {
        "name": "TURKMENISTAN",
        "code": "TKM"
    },
    {
        "name": "TIMOR-LESTE",
        "code": "TLS"
    },
    {
        "name": "TOGO",
        "code": "TOG"
    },
    {
        "name": "CHINESE TAIPEI",
        "code": "TPE"
    },
    {
        "name": "TRINIDAD AND TOBAGO",
        "code": "TTO"
    },
    {
        "name": "TUNISIA",
        "code": "TUN"
    },
    {
        "name": "TURKEY",
        "code": "TUR"
    },
    {
        "name": "TUVALU",
        "code": "TUV"
    },
    {
        "name": "UNITED ARAB EMIRATES",
        "code": "UAE"
    },
    {
        "name": "UGANDA",
        "code": "UGA"
    },
    {
        "name": "UKRAINE",
        "code": "UKR"
    },
    {
        "name": "UN SPECIALISED AGENCY",
        "code": "UNA"
    },
    {
        "name": "UN ORGANISATION",
        "code": "UNO"
    },
    {
        "name": "URUGUAY",
        "code": "URU"
    },
    {
        "name": "UNITED STATES",
        "code": "USA"
    },
    {
        "name": "UZBEKISTAN",
        "code": "UZB"
    },
    {
        "name": "VANUATU",
        "code": "VAN"
    },
    {
        "name": "VATICAN",
        "code": "VAT"
    },
    {
        "name": "VENEZUELA",
        "code": "VEN"
    },
    {
        "name": "VIETNAM",
        "code": "VIE"
    },
    {
        "name": "ST VINCENT AND THE GRENADINES",
        "code": "VIN"
    },
    {
        "name": "STATELESS",
        "code": "XXA"
    },
    {
        "name": "REFUGEE",
        "code": "XXB"
    },
    {
        "name": "YEMEN",
        "code": "YEM"
    },
    {
        "name": "ZAMBIA",
        "code": "ZAM"
    },
    {
        "name": "ZIMBABWE",
        "code": "ZIM"
    }
]

export const timeZones = [
    {
        "name": "European Central Time",
        "timezone": "GMT+1:00",
        "offset": "1:00:00"
    },
    {
        "name": "Eastern European Time",
        "timezone": "GMT+2:00",
        "offset": "2:00:00"
    },
    {
        "name": "(Arabic) Egypt Standard Time",
        "timezone": "GMT+2:00",
        "offset": "2:00:00"
    },
    {
        "name": "Eastern African Time",
        "timezone": "GMT+3:00",
        "offset": "3:00:00"
    },
    {
        "name": "Middle East Time",
        "timezone": "GMT+3:30",
        "offset": "3:30:00"
    },
    {
        "name": "Near East Time",
        "timezone": "GMT+4:00",
        "offset": "4:00:00"
    },
    {
        "name": "Pakistan Lahore Time",
        "timezone": "GMT+5:00",
        "offset": "5:00:00"
    },
    {
        "name": "India Standard Time",
        "timezone": "GMT+5:30",
        "offset": "5:30:00"
    },
    {
        "name": "Bangladesh Standard Time",
        "timezone": "GMT+6:00",
        "offset": "6:00:00"
    },
    {
        "name": "Vietnam Standard Time",
        "timezone": "GMT+7:00",
        "offset": "7:00:00"
    },
    {
        "name": "China Taiwan Time",
        "timezone": "GMT+8:00",
        "offset": "8:00:00"
    },
    {
        "name": "Japan Standard Time",
        "timezone": "GMT+9:00",
        "offset": "9:00:00"
    },
    {
        "name": "Australia Central Time",
        "timezone": "GMT+9:30",
        "offset": "9:30:00"
    },
    {
        "name": "Australia Eastern Time",
        "timezone": "GMT+10:00",
        "offset": "10:00:00"
    },
    {
        "name": "Solomon Standard Time",
        "timezone": "GMT+11:00",
        "offset": "11:00:00"
    },
    {
        "name": "New Zealand Standard Time",
        "timezone": "GMT+12:00",
        "offset": "12:00:00"
    },
    {
        "name": "Midway Islands Time",
        "timezone": "GMT-11:00",
        "offset": "-11:00:00"
    },
    {
        "name": "Hawaii Standard Time",
        "timezone": "GMT-10:00",
        "offset": "-10:00:00"
    },
    {
        "name": "Alaska Standard Time",
        "timezone": "GMT-9:00",
        "offset": "-9:00:00"
    },
    {
        "name": "Pacific Standard Time",
        "timezone": "GMT-8:00",
        "offset": "-8:00:00"
    },
    {
        "name": "Phoenix Standard Time",
        "timezone": "GMT-7:00",
        "offset": "-7:00:00"
    },
    {
        "name": "Mountain Standard Time",
        "timezone": "GMT-7:00",
        "offset": "-7:00:00"
    },
    {
        "name": "Central Standard Time",
        "timezone": "GMT-6:00",
        "offset": "-6:00:00"
    },
    {
        "name": "Eastern Standard Time",
        "timezone": "GMT-5:00",
        "offset": "-5:00:00"
    },
    {
        "name": "Indiana Eastern Standard Time",
        "timezone": "GMT-5:00",
        "offset": "-5:00:00"
    },
    {
        "name": "Puerto Rico and US Virgin Islands Time",
        "timezone": "GMT-4:00",
        "offset": "-4:00:00"
    },
    {
        "name": "Canada Newfoundland Time",
        "timezone": "GMT-3:30",
        "offset": "-3:30:00"
    },
    {
        "name": "Argentina Standard Time",
        "timezone": "GMT-3:00",
        "offset": "-3:00:00"
    },
    {
        "name": "Brazil Eastern Time",
        "timezone": "GMT-3:00",
        "offset": "-3:00:00"
    },
    {
        "name": "Central African Time",
        "timezone": "GMT-1:00",
        "offset": "-1:00:00"
    }
]